const cart = {
    title: 'Il tuo carrello',
    subtitle: 'Rivedi i tuoi prodotti selezionati',
    errorLoading: 'Errore nel caricamento del carrello',
    errorUpdating: 'Errore nell\'aggiornamento della quantità',
    errorRemoving: 'Errore nella rimozione del prodotto',
    errorClearing: 'Errore nella pulizia del carrello',
    confirmClear: 'Sei sicuro di voler svuotare il carrello?',
    emptyCart: 'Il tuo carrello è vuoto',
    checkoutError: 'Errore durante il checkout',
    items: 'articoli',
    clearCart: 'Svuota carrello',
    emptyTitle: 'Carrello vuoto',
    emptySubtitle: 'Aggiungi alcuni prodotti per iniziare',
    browseProducts: 'Sfoglia prodotti',
    orderSummary: 'Riepilogo ordine',
    productsSummary: 'Prodotti',
    subtotal: 'Subtotale',
    shipping: 'Spedizione',
    freeShipping: 'Gratuita',
    total: 'Totale',
    proceedToCheckout: 'Procedi al checkout',
    processing: 'Elaborazione...',
    secureCheckout: 'Checkout sicuro',
    shippingInfo: 'Informazioni spedizione',
    selectShipping: 'Seleziona spedizione',
    shippingAddress: 'Indirizzo di spedizione',
    useProfileAddress: 'Usa indirizzo del profilo',
    editShippingAddress: 'Modifica',
    address: 'Indirizzo',
    city: 'Città',
    postalCode: 'Codice postale',
    country: 'Paese',
    saveAddress: 'Salva indirizzo',
    hide: 'Nascondi',
    addShippingAddress: 'Aggiungi indirizzo di spedizione',
    shippingNotAvailable: 'Spedizione non disponibile',
    shippingNotAvailableMessage: 'Non possiamo spedire all\'indirizzo selezionato. Scegli un altro indirizzo o contattaci per assistenza.',
    availableCountries: 'Paesi disponibili per la spedizione:'
};

export default cart;
